import { render, staticRenderFns } from "./addOrder_01.vue?vue&type=template&id=6385e295&scoped=true"
import script from "./addOrder_01.vue?vue&type=script&lang=js"
export * from "./addOrder_01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385e295",
  null
  
)

export default component.exports